module.exports = __webpack_public_path__ + "img/ede120306889cf1790de07363fbe65ce.png";